import { render, staticRenderFns } from "./psList.vue?vue&type=template&id=711ed306&scoped=true"
import script from "./psList.vue?vue&type=script&lang=js"
export * from "./psList.vue?vue&type=script&lang=js"
import style0 from "./psList.vue?vue&type=style&index=0&id=711ed306&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711ed306",
  null
  
)

export default component.exports